<template>
    <div class="container">
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" style="width:92px;height: 36px;" @click="add('add')">添加</el-button>
                </div>
            </div>
            <div id="base-list" style="margin-top: 30px;">
                <el-table :data="menuList" border row-key="id"
                    :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                    :header-cell-style="{ backgroundColor: '#fafafa', 'text-align': 'left', color: '#333' }">
                    <el-table-column prop="name" label="菜单名称" align="left" header-align="left"></el-table-column>
                    <el-table-column prop="url" label="跳转地址"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="add('edit', scope.row)">查看/编辑</el-button>
                            <el-button type="text" style="color: red;" @click="deleteD(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="height:20px"></div>
        </div>
        <el-dialog :title="title" :visible.sync="isEdit" top="30vh" width="487px" :append-to-body="true">
            <template>
                <el-form :model="newForm" label-width="130px" size="small" style="width: 100%" ref="formRef" :rules="rules">
                    <el-form-item label="菜单名称" prop="name">
                        <el-input placeholder="请输入菜单名称" v-model="newForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="图标" prop="icon" v-if="newForm.levelFlag == 1">
                        <upload-picture :imageUrl="newForm.icon" @getUrl="getImage($event)"></upload-picture>
                    </el-form-item>
                    <el-form-item label="是否为父级菜单" prop="levelFlag">
                        <el-radio v-model="newForm.levelFlag" label="1">是</el-radio>
                        <el-radio v-model="newForm.levelFlag" label="0">否</el-radio>
                    </el-form-item>
                    <el-form-item label="父级菜单" prop="parentId" v-if="newForm.levelFlag == 0">
                        <el-select style="width: 100%" v-model="newForm.parentId" placeholder="请选择父级菜单" filterable
                            clearable>
                            <el-option v-for="item in parentIds" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input placeholder="请输入排序" type="number" v-model="newForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转链接" prop="url">
                        <el-input placeholder="请输入跳转链接" v-model="newForm.url"></el-input>
                    </el-form-item>
                </el-form>

                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isEdit = false">取消</div>
                    <div class="info-s" @click="addAdmin">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
    components: {
        breadcrumbTop,
        uploadPicture
    },
    data() {
        return {
            isD: false,
            dataList: {
                list: [
                    { title: '系统管理', path: '', type: '0' },
                    { title: '菜单列表', path: '', type: '1' }
                ]
            },
            menuList: [],
            newForm: {
                name: '',
                levelFlag: '1',
                parentId: '',
                sort: '',
                url: '',
                icon: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入菜单名称', trigger: 'blur' },
                ],
                levelFlag: [
                    { required: true, message: '请选择是否父级菜单', trigger: 'change' },
                ],
                parentId: [
                    { required: true, message: '请选择父级菜单', trigger: 'change' },
                ],

                sort: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                ],
                url: [
                    { required: true, message: '请输入跳转链接', trigger: 'blur' },
                ],
            },
            parentIds: [],
            title: '添加菜单',
            isEdit: false,
            pageNo: 1,
            pageSize: 10,
            dId: ''
        }
    },
    created() {
        // this.menuList = JSON.parse(sessionStorage.getItem('limit')).menuTreeList
        // console.log(this.menuList)
        this.getM()
        this.getMenus()
    },
    methods: {
        getImage(val) {
            this.newForm.icon = val
        },
        deleteD(id) {
            this.isD = true
            this.dId = id
        },
        submitD() {
            let ids = []
            ids.push(this.dId)
            let data = {
                ids: ids
            }
            this.axios.post('/sysMenu/delete', data)
                .then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.isD = false
                        this.getM()

                    }

                })
        },
        getMenus() {
            this.parentIds = []
            this.axios.get('/sysMenu/getDataList')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item, index) => {
                            let obj = {
                                id: item.id,
                                name: item.name,
                            }
                            this.parentIds.push(obj)
                        })

                    }

                })
        },
        getM() {
            let data = {
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }
            this.axios.post('/sysMenu/getPageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.menuList = res.data.list

                    }

                })
        },
        addAdmin() {
            this.$refs['formRef'].validate((valid) => {
                if (valid) {
                    this.axios.post('/sysMenu/save', this.newForm)
                        .then(res => {
                            if (res.code == 0) {
                                if (this.title == '添加菜单') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                this.isEdit = false
                                this.getM()
                            }

                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        add(type, row) {
            this.getMenus()
            if (type == 'add') {
                this.title = '添加菜单'
                if (this.$refs.formRef) {
                    this.$refs.formRef.resetFields()
                }
                this.newForm.id = ''
            } else {
                this.title = '查看/编辑菜单'
                if (this.$refs.formRef) {
                    this.$refs.formRef.resetFields()
                }
                this.axios.get('/sysMenu/get?id=' + row.id)
                    .then(res => {
                        if (res.code == 0) {
                            res.data.levelFlag = String(res.data.levelFlag)
                            this.newForm = res.data
                        }

                    })

            }
            this.$nextTick(() => {
                this.isEdit = true
            })

        }
    }
}
</script>
<style scoped lang="scss">
.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/deep/ .el-table td {
    text-align: left;
}

/deep/ .el-table th>.cell {
    text-align: left;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
</style>